import React, { memo } from "react";

import { formatCurrencyNoCent } from "../../../utils/NumbersFormatting";
import { RoundedStatusBadge } from "../../RoundedStatusBadge/RoundedStatusBadge";

interface CostColumnProps {
  prices: {
    inputTokensPrice: number;
    outputTokensPrice: number;
  };
  isFree: boolean;
}

const CostColumn: React.FC<CostColumnProps> = memo(({ prices, isFree }) => {
  return (
    <div className="cost-column">
      <div className="d-flex align-center me-2">
        {prices && (
          <div>
            {formatCurrencyNoCent(
              prices.inputTokensPrice + prices.outputTokensPrice,
            )}
          </div>
        )}
      </div>
      {isFree && <div className="resp-badge resp-success">FREE</div>}
    </div>
  );
});
export { CostColumn };
